import Encoding from "encoding-japanese";

import toastr from 'toastr';
import _ from 'lodash';

import MapGroupModalView from "./mapsGroupsModal.html";
import AddNewGroupModalView from "../persons/addGroupModal.html";
import PositionModalView from "./PositionModal.html";
import GroupGroupModalView from "./GroupGroupModal.html";

angular.module("groups")

    .controller("GroupsListCtrl", ['LoginService', '$rootScope', '$scope', '$http', 'generateDocumentService', '$q', 'i18nService', 'Restangular', 'uiGridTreeViewConstants', 'gridService', 'treeService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'datasetsService', 'logService',
        function (LoginService, $rootScope, $scope, $http, generateDocumentService, $q, i18nService, Restangular, uiGridTreeViewConstants, gridService, treeService, modalService, $uibModal, $filter, $translate, $state, datasetsService, logService) {
            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("GROUPS_WRITE");
            $scope.allowImport = LoginService.permissionExist("PERSONS_IMPORT");
            $scope.showNewData = false;
            $scope.military_groups_enabled = false;
            $scope.search = false;
            $scope.searchValues = { show_empty_positions: true };
            $scope.selected = {};
            $scope.group_type = "civil";

            $rootScope.title = $filter('translate')('groups.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('groups.title') }
            ];

            $scope.listPositionsIds = [];
            $scope.listGroupsIds = [];

            $scope.showOptions = false;
            // mostrar opciones de seleccionar/deseleccionar todo

            // mostrar opciones de seleccionar/deseleccionar todo

            // Vamos is hay que mostrar el tab de grupos  civiles y militares

            $scope.loadCompany = function () {
                Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
                    $scope.military_groups_enabled = results.military_groups_enabled;
                    $scope.default_order_article = results.default_order_article;
                }); 
            };

            setTimeout(function () {
                $scope.loadCompany();
            });

            $scope.gridOptions = {
                pdfTitle: "Grupos",
                exporterMenuCsv: true,
                enableGridMenu: true,
                enableSorting: false,             
                showTreeExpandNoChildren: false,
                expandAllRows: true,
                paginationPageSizes: [50, 200, 500],
                paginationPageSize: 50,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                exporterFieldCallback: function (grid, row, col, value) {
                    if (col.name == 'customName') {
                        return row.entity.customNamePDF;
                    } else {
                        return value;
                    }
                },

                columnDefs: [
                    {
                        name: 'customName', displayName: $filter('translate')('groups.name'), enableFiltering: false,
                        enableHiding: false, cellTemplate: '<div ng-bind-html="row.entity[col.field] | to_trusted"></div>'
                    },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('groups.edit'), action: 'ui-sref="groups.edit({group_id:row.entity.group_id,id:row.entity.id})"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('groups.delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    options.customName = $scope.searchValues.name;
                    var deferred = $q.defer();                
                    Restangular.all('Groups').getList(options).then(function (results) {
                        var data = treeService.groups(results, null);
                        data.totalRows = results.totalRows;                                                  
                        deferred.resolve(data);
                    }, function (response) {
                        deferred.reject(response);
                    });
                    return deferred.promise;
                }
            };

            $scope.goToEdit = function (rowEntity) {
                $state.go("groups.edit", { group_id: rowEntity.group_id, id: rowEntity.id });
            }

            $scope.goToAdd = function (rowEntity) {

                let options: any = {};

                if (rowEntity) {
                    options.descendsFrom = rowEntity.id
                };
                if ($scope.group_type) {
                    options.group_type = $scope.group_type;
                }

                $state.go("groups.edit", options);
            }
        
            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('groups.delete'),
                    message: $filter('translate')('groups.delete_message')+" " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Groups', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('groups.delete_ok'));
                            //$scope.gridOptions.data = $scope.gridOptions.data.filter(function (el) { return el.id != $scope.id; });
                            $scope.gridOptions.loadData();
                        }, function (response) {
                            logService.error("Error with status code", response.status);
                        });
                    }
                });
            };
        
            $scope.mapGroup = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: MapGroupModalView,
                    size: "x-lg",
                    controller: "MapGroupModalCtrl",
                    scope: $scope
                });
            };

            $scope.export = function () {
                var options = {
                    filters: {
                        NAME: $scope.searchValues.name,
                        TYPE: $scope.group_type != null ? $scope.group_type : "civil"
                    }
                };

                datasetsService.exportByType("groups", options);
            };
        
            $scope.groupsLoaded = [];

            $scope.loadDataNew = function (aux, id) {

                let options = { 
                    id: id, customName: $scope.searchValues.name, show_empty_positions: $scope.searchValues.show_empty_positions, group_type: $scope.group_type
                };
            
                if (id == null) {                
                    $http({
                        method: 'get',
                        url: (window as any).CONFIG.api_url + 'Groups/GetGroupsFromId',
                        params: options
                    }).then(function (results, status, headers, config) {
                        $scope.newData = results.data;                    
                        $scope.showNewData = true;
                    });
                } else {
                    //miramos si ya está descargado, si es así, lo eliminamos del array
                    if (aux.FK_groups_groups_groups1 == null) {
                        $scope.groupsLoaded[id] = true;
                        $http({
                            method: 'get',
                            url: (window as any).CONFIG.api_url + 'Groups/GetGroupsFromId',
                            params: options
                        }).then(function (results, status, headers, config) {
                            if (id == null) {
                                $scope.newData = results.data;
                            } else {
                                //buscamos la posición donde ponerlo......
                                aux.FK_groups_groups_groups1 = results.data;
                            }
                            $scope.showNewData = true;
                        });
                    } else {
                        aux.FK_groups_groups_groups1 = null;
                        $scope.groupsLoaded[id] = false;
                    }
                }

            }

            // Cambiamos el tipo de grupo 
            $scope.changeGroupType = function (group_type) {

                $scope.listPositionsIds = [];
                $scope.listGroupsIds = [];

                $scope.group_type = group_type;
                $scope.loadDataNew(null);

            }

            /* Al cargarse el DOM, la función  $scope.changeGroupType  (y por tanto la función $scope.loadDataNew) se aplica automáticamente, 
             porque está ligada en el atributo selected del uib - tab, que aparece seleccionado por defecto.
             Para que no llamar a lso datos 2 veces, dejo esta llamada comentada */
            // $scope.loadDataNew(null);

            $scope.addNewGroup = function (group_id) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddNewGroupModalView,
                    controller: "AddNewGroupModalCtrl",
                    size: "lg",
                    resolve: {
                        group_id: function () {
                            return group_id;
                        }
                    }
                });
                $modalInstance.result.then(function (result) {
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            };

            $scope.addPosition = function (group) {

                let position: any = { isNew: true };
                position.group_id = group.id;
                position.position_type = group.group_type;
                position.FK_positions_tl_positions = [];
                position.FK_positions_contacts_positions = [];
                position.FK_positions_addresses_positions = [];

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: PositionModalView,
                    controller: "PositionModalCtrl",
                    size: 'lg',
                    resolve: {
                        position: function () {
                            return position;
                        }, position_list: function () {
                            return null;
                        }, group: function () {
                            return group;
                        }, fromView: function () {
                            return "Groups";
                        }
                    }

                });
                $modalInstance.result.then(function (resultModal) {
                    var resultvalue = resultModal.edited;
                    Restangular.all("positions/").post(resultvalue).then(function (result) {
                        //buscamos referencia y añadimos nueva posicion
                        group.FK_positions_groups.push(result);
                    });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                });
            }

            $scope.editPosition = function (position, group) {
                Restangular.one("Positions", position.id).get().then(function (res) {

                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: PositionModalView,
                        controller: "PositionModalCtrl",
                        size: 'lg',
                        resolve: {
                            position: function () {
                                return res;
                            }, position_list: function () {
                                return null;
                            }, group: function () {
                                return null;
                            }, fromView: function () {
                                return "Groups";
                            }
                        }

                    });
                    $modalInstance.result.then(function (resultModal) {

                        var resultvalue = resultModal.edited;
                        var deletedValue = resultModal.deleted;
                        if (typeof deletedValue != "undefined") {
                            group.FK_positions_groups.splice(deletedValue);
                        } else {
                            Restangular.all("positions/" + resultvalue.id).customPUT(resultvalue).then(function (result) {
                                //buscamos referencia y reemplazamos completa
                                var positionRestored = $filter('filter')(group.FK_positions_groups, { id: position.id }, true)[0];

                                positionRestored.FK_positions_tl_positions[0].name = result.name;
                            });
                        }
                    }, function () {
                    });
                })
            
            };

            $scope.toggleCheckGroup = function (group, checked) {
                if (checked == true) {
                    angular.forEach(group.FK_positions_groups, function (value) {
                        if ($scope.listPositionsIds.indexOf(value.id) === -1) {
                            $scope.listPositionsIds.push(value.id);
                            value.checked = true;
                        }
                    })
                } else {
                    angular.forEach(group.FK_positions_groups, function (value) {
                        if ($scope.listPositionsIds.indexOf(value.id) !== -1) {
                            $scope.listPositionsIds.splice($scope.listPositionsIds.indexOf(value.id), 1) ; //se elimina del array
                            value.checked = false;
                        }
                    });
                }
            }

            $scope.toggleCheckPosition = function (item) {

                if ($scope.listPositionsIds.indexOf(item.id) === -1 && item.checked) {
                    $scope.listPositionsIds.push(item.id);
                } else {
                    $scope.listPositionsIds.splice($scope.listPositionsIds.indexOf(item.id), 1);
                }
            };

            $scope.toggleCheckGroupItself = function (item) {
                if ($scope.listGroupsIds.indexOf(item.id) === -1 && item.checked) {
                    $scope.listGroupsIds.push(item.id);
                } else {
                    $scope.listGroupsIds.splice($scope.listGroupsIds.indexOf(item.id), 1);
                }
            };

            $scope.movePositions = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: GroupGroupModalView,
                    controller: "GroupGroupModalCtrl",
                    size: 'lg',
                    resolve: {
                        parent_list: function () {
                            return [];
                        },
                        allow_select_multple: function () {
                            return false;
                        },
                        show_color: function () {
                            return false;
                        },
                        group_type: function () {
                            return $scope.group_type != null ? $scope.group_type : "civil";
                        }

                    }
                });


                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (data) {
                    var groupId = data.parents_clone;
                                
                    //movemos las posiciones a ese grupo.
                    if (groupId.length > 0) {
                        Restangular.all('Positions').customGET("MovePositionsToGroup", { group_id: groupId[0].parent_group_id, positionsIds: $scope.listPositionsIds }).then(function (result) {
                            if (result) {
                                toastr.success($filter('translate')('position.move_success'));
                                $scope.loadDataNew(null);
                                $scope.listPositionsIds = [];
                            } else {
                                toastr.error($filter('translate')('position.move_error'))
                            }
                        });
                    }
                    if (!$scope.$$phase) $scope.$apply();

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });
            };

            $scope.moveGroups = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: GroupGroupModalView,
                    controller: "GroupGroupModalCtrl",
                    size: 'lg',
                    resolve: {
                        parent_list: function () {
                            return [];
                        },
                        allow_select_multple: function () {
                            return false;
                        },
                        show_color: function () {
                            return false;
                        },
                        group_type: function () {
                            return $scope.group_type != null ? $scope.group_type : "civil";
                        }
                    }
                });

                $modalInstance.result.then(function (data) {

                    logService.debug('data');
                    logService.debug(data);

                    var groupId = data.parents_clone;

                    logService.debug(`groupId = ${groupId}`);

                    //movemos las posiciones a ese grupo.
                    if (groupId.length > 0) {
                        Restangular.all('Groups').customGET("MoveGroupsToGroup", { group_id: groupId[0].parent_group_id, groupsIds: $scope.listGroupsIds }).then(function (result) {
                            if (!result.success) {
                                modalService.message({
                                    title: "Error", 
                                    message: result.message,
                                    onAccept: function () { }
                                });

                            } else {
                                toastr.success($filter('translate')('groups.move_success'));
                                $scope.loadDataNew(null);
                                $scope.listGroupsIds = [];
                            }
                        });
                    }
                    
                    if (!$scope.$$phase) $scope.$apply();

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });
            }

            $scope.printGroupsAuthoritiesTree = function (group_id) {
                var params = {
                    entity_type: "groups",
                    entity_type_id: null,
                    documents: { codes: ["GROUPS_AUTHORITIES"] }
                };
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, group_id: group_id, order: 'prefered', outputType: 'pdf' }
                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })
                    }
                });
            };

            $scope.goToAuthoritiesList = function (group) {
                var url = $state.href('persons.list', {
                    person_type: 'authority',
                    reset: false,
                    group_id: group.id
                });

                window.open(url, '_blank');
                
            };

            // Importación CSV

            // Personas

            let importCSVConfigured = false;
            let groupImportId = null;

            let initImportCSV = function () {
                $("#frmCSV").change(function () {
                    let fileInput = document.querySelector('#frmCSV') as HTMLInputElement;
                    let file = fileInput?.files?.[0];
                    if (file) {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            const codes = new Uint8Array(e.target?.result as ArrayBuffer);
                            const detectedEncoding = Encoding.detect(codes);
                            try {
                                let unicodeString = Encoding.convert(codes, {
                                    to: 'unicode',
                                    from: detectedEncoding,
                                    type: 'string'
                                });

                                let request = {
                                    file: btoa(unicodeString),
                                    person_type: "anonymous",
                                    mime: file.type
                                }

                                Restangular.all('Persons/ImportCSV?group_id=' + groupImportId).post(request).then(function (data) {
                                    $state.go('groups.import_people', { people: data, group_id: groupImportId});
                                });
                            } catch (e) {
                                // Uncaught RangeError: Maximum call stack size exceeded
                            }
                        };

                        reader.readAsArrayBuffer(file);

                    }
                });
            };

            $scope.importCSV = function(group_id) {
                groupImportId = group_id;
                if(!importCSVConfigured) {
                    importCSVConfigured = true;
                    initImportCSV();
                }
                $("#frmCSV").trigger("click");
            };

            // Grupos 
            let importGroupCSVConfigured = false;

            let initImportGroupCSV = function () {
                $("#frmGroupCSV").change(function () {
                    let fileInput = document.querySelector('#frmGroupCSV') as HTMLInputElement;
                    let file = fileInput?.files?.[0];
                    if (file) {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            const codes = new Uint8Array(e.target?.result as ArrayBuffer);
                            // @ts-ignore
                            const detectedEncoding = Encoding.detect(codes);
                            try {
                                // @ts-ignore
                                let unicodeString = Encoding.convert(codes, {
                                    to: 'unicode',
                                    from: detectedEncoding,
                                    type: 'string'
                                });

                                let request = {
                                    file: btoa(unicodeString),
                                    person_type: "anonymous",
                                    mime: file.type
                                }
                                Restangular.all('Groups/ImportCSV').post(request).then(function (data) {
                                    $state.go('groups.import_group', { groupRows: data });
                                });
                            } catch (e) {
                                // Uncaught RangeError: Maximum call stack size exceeded
                            }
                        };

                        reader.readAsArrayBuffer(file);
                    }
                });
            };

            $scope.importGroupCSV = function () {

                if (!importGroupCSVConfigured) {
                    importGroupCSVConfigured = true;
                    initImportGroupCSV();
                }
                $("#frmGroupCSV").trigger("click");
            };

            $scope.printGroupsTree = function () {
                var params = {
                    entity_type: "groups",
                    entity_type_id: null,
                    documents: { codes: ["GROUPS_AUTHORITIES"] }
                };
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: { document_id: item.document_id, group_id: 0, order: 'prefered', outputType: 'pdf' }
                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })
                    }
                });
            };

    }])


    .controller("MapGroupModalCtrl", [ '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', 'treeService', function ($scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, treeService) {

        $scope.space = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        Restangular.all('Groups').getList({group_type : $scope.group_type}).then(function (results) {

            var data = treeService.groups(results, null);
            $scope.groups = data;
        });

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

;